import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Messages from './Messages';

import s from './HistoryEvents.css';

class HistoryEventRow extends React.Component {
  
  getBoxWrapStyle = (deviceType, center) => {
    const isSuperior = deviceType === 'superior';

    let wrapStyle = cx();
    if (center) {
      wrapStyle = isSuperior
        ? cx(s.spirotech_data_color, s.center)
        : cx(s.data_color, s.center);
    } else {
      wrapStyle = isSuperior ? cx(s.spirotech_data_color) : cx(s.data_color);
    }
    return wrapStyle;
  };

  showBox = (element, index, messages, deviceDocument) => {
    const deviceType = deviceDocument.get('deviceType');
    const screenType = deviceDocument.get('screenType');

    const visible = this.getColumnVisibilityByIndex(
      index,
      this.props.documentSoftenerFilter,
      this.props.documentSuperiorFilter,
      deviceType,
      screenType,
    );
    
    const wrappedStyle = this.getBoxWrapStyle(deviceType);
    const wrappedStyleCenter = this.getBoxWrapStyle(deviceType, true)
    if (visible) {
      const isArray = Object.prototype.toString.call(element) === '[object Object]';
      if (isArray) {
        const value = element.get(0);
        if (value !== '') {
          return (
            <td 
              className={wrappedStyle}
              onClick={this.props.onClick}
              key={index}
            >
              <FormattedMessage {...messages[value]} />
            </td>
          );
        }
        return (
          <td className={wrappedStyleCenter} key={index}>
            {element}
          </td>
        );
      }
      return (
        <td className={wrappedStyleCenter} key={index}>
            {element}
        </td>
      );
    }
    return null;
  };

  getColumnVisibilitySoftenerItems = (documentSoftenerFilter, screenType) => {
    const values = [
      documentSoftenerFilter.get('date'),
      documentSoftenerFilter.get('time'),
      documentSoftenerFilter.get('event'),
      documentSoftenerFilter.get('daily_water_usage'),
      documentSoftenerFilter.get('weekly_water_usage'),
      documentSoftenerFilter.get('monthly_water_usage'),
      documentSoftenerFilter.get('total_water_usage'),
      documentSoftenerFilter.get('untreated_water_flow'),
      documentSoftenerFilter.get('water_flow'),
      documentSoftenerFilter.get('water_pressure'),
      documentSoftenerFilter.get('max_water_pressure'),
      documentSoftenerFilter.get('min_water_pressure'),
      documentSoftenerFilter.get('max_water_flow'),
      documentSoftenerFilter.get('normal_regeneration_number'),
      documentSoftenerFilter.get('service_regeneration_number'),
      documentSoftenerFilter.get('incomplete_regeneration_number'),
    ];

    const values2 = [
      documentSoftenerFilter.get('chlor_current'),
      documentSoftenerFilter.get('ip_address'),
      documentSoftenerFilter.get('subnet_mask'),
      documentSoftenerFilter.get('default_gateway'),
      documentSoftenerFilter.get('device_operator'),
      documentSoftenerFilter.get('record_no'),
    ];
    const retValues = [
      ...values,
      ...this.getReserve(documentSoftenerFilter, screenType),
      ...values2,
    ];
    return retValues;

  };

  getReserve = (documentSoftenerFilter, screenType) => {
    switch (screenType) {
      case 'DOUBLEALTERNATIVE':
      case 'DOUBLEPARALLEL':
      case 'DOUBLEFILTER':
        return [
          documentSoftenerFilter.get('a_cylinder_reserve'),
          documentSoftenerFilter.get('c_cylinder_reserve'),
          documentSoftenerFilter.get('b_cylinder_reserve'),
        ];
      case 'TRIPLEALTERNATIVE':
      case 'TRIPLEPARALLEL':
      case 'TRIPLEFILTER':
        return [
          documentSoftenerFilter.get('b_cylinder_reserve'),
          documentSoftenerFilter.get('a_cylinder_reserve'),
          documentSoftenerFilter.get('c_cylinder_reserve'),
        ];
      default:
        return [
          documentSoftenerFilter.get('a_cylinder_reserve'),
          documentSoftenerFilter.get('b_cylinder_reserve'),
          documentSoftenerFilter.get('c_cylinder_reserve'),
        ];
    }
  };

  getColumnVisibilitySuperiorItems = documentSuperiorFilter => {
    const values = [
      documentSuperiorFilter.get('date'),
      documentSuperiorFilter.get('time'),
      documentSuperiorFilter.get('event'),
      documentSuperiorFilter.get('current_refill_flow'),
      documentSuperiorFilter.get('refill_flow_rate'),
      documentSuperiorFilter.get('total_refill_volume'),
      documentSuperiorFilter.get('system_pressure'),
      documentSuperiorFilter.get('total_refill_time'),
      documentSuperiorFilter.get('total_degass_time'),
      documentSuperiorFilter.get('device_operator'),
      documentSuperiorFilter.get('record_no'),
    ];
    return values;
  };

  getColumnVisibilityByIndex = (
    index,
    documentSoftenerFilter,
    documentSuperiorFilter,
    deviceType,
    screenType,
  ) => {
    let values = [];
    let ret = 0;
    switch (deviceType) {
      case 'charlie':
      case 'softener':
      case 'simplex':
        values = this.getColumnVisibilitySoftenerItems(documentSoftenerFilter, screenType);
        ret = values[index];
        break;
      case 'superior':
        values = this.getColumnVisibilitySuperiorItems(documentSuperiorFilter);
        ret = values[index];
        break;
      default:
        break;
    }
    return ret;
  };

  isRowVisible = eventValue => {
    if (+this.props.filteredEvents.length !== 0) {
      if (this.props.filteredEvents.indexOf(eventValue) < 0) {
        return false;
      }
      return true;
    }
    return true;
  };


  render() {
    const messages = Messages();
    const { row, colorId, deviceDocument } = this.props;
    if (typeof row !== 'undefined') {
      const eventValue = row.get(2).get(1);
      const highlightedValue = colorId === eventValue;
      const wrapStyle = highlightedValue
        ? cx(s.row_container, s.red) 
        : cx(s.row_container);
      const rowVisible = this.isRowVisible(eventValue);
      if (rowVisible) {
        return (
          <tr className={wrapStyle}>
            {row.map((element, ind) =>
              this.showBox(element, ind, messages, deviceDocument)
            )}
          </tr>
        );
      }
      return null;
    }
    return null;
  }
}

HistoryEventRow.propTypes = {
  row: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClick: PropTypes.func.isRequired,
  colorId: PropTypes.string.isRequired,
  filteredEvents: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withStyles(s)(HistoryEventRow);



// WEBPACK FOOTER //
// ./src/components/HistoryEvents/HistoryEventRow.js